module.exports = __webpack_public_path__ + "img/private-pizzeriano3-salat.125d0457.jpg";